import { Box } from "@mui/material"
import { useFindSensor, useFindSensorInstallationsForSensor } from "../../api/SensorInstallApi"
import { BackButton } from "../../components/BackButton"
import { NexPageContainer } from "../../components/NexPageContainer"
import { Title } from "../../components/Typography/Typography"
import { useNexusSensorIdOptional, useSensorInstallSearchFiltersWithDefaults } from "../../hooks/useNexusParams"
import { sensorInstallBaseColumns } from "./table/SensorInstallColumns"
import { SensorInstallTable } from "./table/SensorInstallTable"

// Show all sensor installations for a specific sensor (that has sensor installs)
export const SensorInstallsForSensorTable = () => {
    const sensorId = useNexusSensorIdOptional()
    const currentFiltersWithDefaults = useSensorInstallSearchFiltersWithDefaults()

    const sensorResult = useFindSensor(sensorId)
    const sensorType = sensorResult.data

    const sensorInstallResults = useFindSensorInstallationsForSensor(currentFiltersWithDefaults, sensorId)
    const sensorInstallations = sensorInstallResults.data

    return (
        <NexPageContainer py={4}>
            <Title>
                Sensor Installations for Sensor {sensorType?.sensor_model} - {sensorType?.serial_number ?? ""}
            </Title>
            <Box sx={{ my: 2 }}>
                <SensorInstallTable
                    columns={sensorInstallBaseColumns}
                    rows={sensorInstallations?.results}
                    count={sensorInstallations?.count}
                    isLoading={sensorInstallResults.isPending}
                />
            </Box>
            <BackButton />
        </NexPageContainer>
    )
}
